import SelectCheckbox from './NewFullNameCell';

export default SelectCheckbox;
